export default __webpack_public_path__ + "static/media/section17 mobile.38e8d006.png";